import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { Subject } from 'rxjs';
import * as period from '../../../../data/period.json';
import { DateService } from '../service/date.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { FileExportService } from '../../../../@core/backend/common/services/file-export.service';
import { PatientRegistrationData } from '../../../../@core/interfaces/patient-services/patient-registration';
import { PatientLogReportPrintComponent } from '../patient-log-report-print/patient-log-report-print.component';
import { Location } from '@angular/common';
import { access } from '../../../../data/access-constants';

@Component({
  selector: 'ngx-patient-log-report',
  templateUrl: './patient-log-report.component.html',
  styleUrls: ['./patient-log-report.component.scss']
})
export class PatientLogReportComponent implements OnInit {
  sortColumn: string = '';
  sortOrder: boolean = true; // true for ascending, false for descending
  patientLogReports: Array<any> = [];
  data: Array<any> = [];
  protected readonly unsubscribe$ = new Subject<void>();
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  periodList: string[] = (period as any).default;
  searchForm: FormGroup;
  max = this.dateobj.currentDate();
  isSubmitted: boolean = false;

  moreDetails: boolean = false;
  rangeDate: Date[] = [];
  DateExceeds: boolean = false;
  p: number = 1;
  actionList: Array<any> = [{ id: 1, name: 'Save' }, { id: 2, name: 'Update' }, { id: 3, name: 'Delete' }, { id: 4, name: 'Cancel' }, { id: 0, name: 'All' }];
  patientData: any = {};
  count: number = 0;
  @ViewChild(PatientLogReportPrintComponent) printActionInstance: PatientLogReportPrintComponent;
  isClicked: boolean = false;
  term: string;
  @Input() fromDashBoard: boolean = false;
  @Input() regId: string;
  @Input() regNums:string;
  @Input() billId:string |number;

  regNum: string;
  sourceType: string;
  admissionNumber: string;
  action: string;
  fromDate: Date;
  toDate: Date;
  sourceTypeList: Array<any> = [];
  isExport:boolean=false
  isPrint:boolean=false
  pageTaskIds: any = [];
  userAccessData: any;
  get apiUrl() { return environment.baseUrl; }

  @Input() billingView;

  constructor(public location: Location, protected patRegSrvc: PatientRegistrationData, private rolesData: RolesData, public dateobj: DateService, private fb: FormBuilder, private filexport: FileExportService) {
    this.searchForm = this.fb.group({
      fromDate: this.fb.control(null, [Validators.required]),
      toDate: this.fb.control(null, [Validators.required]),
      period: this.fb.control('Today'),
      regNum: this.fb.control(null),
      sourceType: this.fb.control(null),
      admissionNumber: this.fb.control(null,Validators.pattern('^[0-9]+$')),
      action: this.fb.control([2, 3, 4])
    });

    this.searchForm.get('period').valueChanges.subscribe(
      (period) => {

        if (period == 'Between') {
          this.searchForm.get('fromDate').setValidators([Validators.required]);
          this.searchForm.get('toDate').setValidators([Validators.required]);
        }
        else {
          this.searchForm.get('fromDate').clearValidators();
          this.searchForm.get('toDate').clearValidators();
        }

      }
    );

  }

  selectAction(event) {
    let action = [];
    if (event && event?.length > 0) {
      action = event.map((item: any) => item.value);
    }
    if (action.includes(0)) {
      if (action[action?.length - 1] == 0) {
        setTimeout(() => {
          this.fval.action.setValue([0]);
        })

      } else {
        const det = action.filter(action => action != 0)
        setTimeout(() => {
          this.fval.action.setValue(det);
        })
      }
    }
    else {
      const temp = this.actionList?.filter(x => x.id != 0).map(x => x.id);
    
      if (action.length == temp.length && temp.every(id => action.includes(id)))
      {
        setTimeout(() => {
          this.fval.action.setValue([0]);
        });
      }
    }
    
  }
billingLoad(){
   this.fval?.action.setValue(null);
      this.fval?.sourceType.setValue(7);
      this.fval?.regNum?.setValue(this.regNums)
      this.onSearch();
}

  ngOnInit(): void {
    this.searchForm?.markAsTouched();
    if(this.billingView){
     this.sourceTypeList= [{id: 7, sourceType: "OPBill"}]
     this.billingLoad();
    }else{
    this.loadSourceMaster();
    this.onSearch();
    }
    this.fetchPageAccess()
  }
  fetchPageAccess() {
    this.pageTaskIds = [];
    this.pageTaskIds.push(access.task.PAT_LOG_MGMT_SYS);
    let matrixSearchData = {
      taskId: this.pageTaskIds,
      UserId: localStorage.getItem("userType")
    }
    this.rolesData.create(`${this.apiUrl}/userrole/${this.tenantId}/${this.branchId}/pageaccesssearch`, matrixSearchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.userAccessData = data;

    }, (error) => {
    }, () => {
   
      let Print = this.userAccessData.filter(element => access.task.PAT_LOG_MGMT_SYS == element.taskID && element.actionID == access.action.PRINT && element.permission == "true");
      if (Print.length > 0) this.isPrint = true;
      let Export = this.userAccessData.filter(element => access.task.PAT_LOG_MGMT_SYS == element.taskID && element.actionID == access.action.EXPORT && element.permission == "true");
      if (Export.length > 0) this.isExport = true;


    });



  }

  utcToLocalConversion(date) {
    if (date != null && date != "" && date != undefined) {
      return this.dateobj?.dateUtctoLocalDateAndTime(date);
    }
  }

  patientListLoad(regId) {
    if (regId !== null && regId !== undefined) {
      this.patRegSrvc.getById('patientregistrationmst/' + this.tenantId + '/' + this.branchId + '/' + regId)
        .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.patientData = data;
        }, (error) => {
        }, () => {
        });
    }
  }


  onSearch() {
    this.onLoad();
    this.isSubmitted = true;
    if (this.searchForm?.untouched) {
      return;
    }
    if (this.searchForm.valid) {
      let action = this.fval?.action.value;
      if (action && action.includes(0)) {
        action = null;
      }
      let postDate = {
        regNum: (!!this.fval?.regNum.value) ? this.fval?.regNum.value : null,
        sourceType: this.fval?.sourceType.value,
        admissionNumber: (!!this.fval?.admissionNumber.value) ? this.fval?.admissionNumber.value : null,
        action: action,
        fromDate: this.dateobj.utcFromDate(this.fval?.fromDate.value),
        toDate: this.dateobj.utcToDate(this.fval?.toDate.value),
        billId : this.billingView?this.billId:null
      }
      this.rolesData.create(`${environment.apiUrl}/patientUrology/getNonClinicalTimelineDet?tenantId=${this.tenantId}&branchId=${this.branchId}`, postDate).pipe(takeUntil(this.unsubscribe$)).subscribe(
        (data) => {
          this.patientLogReports = data?.details;
          this.patientLogReports?.forEach((list) => {
            list.sourceTypeName = this.sourceTypeList?.find(x => x.id == list.sourceType)?.sourceType;
            list.actionName = this.actionList?.find(x => x.id == list.action)?.name;
            list.sourceLabel = list?.sourceType==1 ? 'Reg' : list?.sourceType==2 ?  'Adm' : list?.sourceType==3 ? 'Discharge Notification' : list?.sourceType==4 ?  'Discharge Entry': list?.sourceType==5 ? 'Bed Transfer' : list?.sourceType==6 ? 'Room Rent' : list?.sourceType==7 ? 'OP Bill' : list?.sourceType==8 ? 'IP Bill' : list?.sourceType==9 ? 'IP Advance': list?.sourceType==13 ? 'Appt' : list.sourceTypeName ;
          });
          this.data = this.patientLogReports;
        }, (error) => {
          if (error?.status == 404) {
            this.patientLogReports = [];
            this.data = this.patientLogReports;
            this.searchForm?.markAsUntouched();
            this.storeValues();
          }
        },
        () => {
          this.isSubmitted = false;
          this.searchForm?.markAsUntouched();
          this.storeValues();
        }
      )
    }
  }

  get fval(): { [key: string]: AbstractControl } { return this.searchForm.controls; }


  onReset(): void {
    this.moreDetails = false;
    this.searchForm?.reset();
    this.term = '';
    this.searchForm?.markAsTouched();
    this.fval.action?.setValue([2, 3, 4]);
    this.fval.period?.setValue('Today');
    this.isSubmitted = false;
     if(this.billingView){
     this.billingLoad()
    }else{
    this.onSearch();
    }
    //this.onSearch();
  }

  prevclicked() {
    if (this.p > 1) {
      this.p = this.p - 1;
    }
  }

  nextclicked() {
    if (this.p < Math.ceil(this.patientLogReports?.length / 10)) {
      this.p += 1;
    }
  }

  onDateChoose() {
    var fromDate = this.searchForm.get('fromDate').value;
    var toDate = this.searchForm.get('toDate').value;
    if (fromDate != undefined && toDate != undefined && fromDate != null && fromDate != ""
      && toDate != null && toDate != "") {
      fromDate = formatDate(fromDate, 'yyyy-MM-dd', 'en-US');
      toDate = formatDate(toDate, 'yyyy-MM-dd', 'en-US');
      if (fromDate <= toDate) {
        this.DateExceeds = false;
      }
      else {
        this.DateExceeds = true;
      }
    }
  }

  storeValues() {
    this.regNum = this.fval?.regNum.value;
    this.sourceType = this.sourceTypeList?.find(x => x.id == this.fval?.sourceType?.value)?.sourceType;
    this.admissionNumber = this.fval?.admissionNumber.value;
    const actionIds = this.fval?.action?.value || [];
    this.action = this.actionList?.filter(item => actionIds.includes(item.id)).map(item => item.name).join(',');
    this.fromDate = this.fval?.fromDate.value;
    this.toDate = this.fval?.toDate.value;
  }

  periodChange(data: any[]) {
    this.searchForm.get('period').setValue(data[0]?.value);
    if (data[0]?.value == "Between") {
      this.searchForm.get('fromDate').setValue(null);
      this.searchForm.get('toDate').setValue(null);
      this.moreDetails = true;
      this.isSubmitted = false;
    }
    else {
      this.rangeDate = null;
      this.moreDetails = false;
    }
  }

  onLoad() {
    var date = this.dateobj.currentDate();
    if (this.fval.period?.value != "" && this.fval.period?.value != "Between") {
      switch (this.fval.period?.value) {
        case 'Today':
          this.rangeDate = null;
          this.fval.fromDate?.setValue(date);
          this.fval.toDate?.setValue(date);
          break;
        case 'Yesterday':
          date.setDate(date.getDate() - 1);
          this.fval.fromDate?.setValue(date);
          this.fval.toDate?.setValue(date);
          break;
        case 'This Week':
          var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
          this.fval.fromDate?.setValue(new Date(today.setDate(today.getDate() - today.getDay())));
          this.fval.toDate?.setValue(date);
          break;
        case 'This Month':
          this.fval.fromDate?.setValue(new Date(date.getFullYear(), date.getMonth(), 1));
          this.fval.toDate?.setValue(date);
          break;
        case 'This Year':
          this.fval.fromDate?.setValue(new Date(date.getFullYear(), 0, 1));
          this.fval.toDate?.setValue(date);
          break;
        case 'All':
          this.fval.fromDate?.setValue(null);
          this.fval.toDate?.setValue(date);
          break;
        default:
          break;
      }
    }
    if (this.rangeDate !== null && this.rangeDate !== undefined) {
      if (this.rangeDate[0] !== null && this.rangeDate[0] !== undefined && (this.rangeDate[1] == null || this.rangeDate[1] == undefined)) {
        this.fval.fromDate?.setValue(this.rangeDate[0]);
        this.fval.toDate?.setValue(date);
      }
      else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] == null || this.rangeDate[0] == undefined)) {
        this.fval.fromDate?.setValue(null);
        this.fval.toDate?.setValue(this.rangeDate[1]);
      }
      else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] != null && this.rangeDate[0] != undefined)) {
        this.fval.fromDate?.setValue(this.rangeDate[0]);
        this.fval.toDate?.setValue(this.rangeDate[1]);
      }
    }

  }

  sortTable(column: string) {
    // Toggle sorting order if the same column is clicked
    if (this.sortColumn === column) {
      this.sortOrder = !this.sortOrder;
    } else {
      this.sortColumn = column;
      this.sortOrder = true;
    }

    // Sort the patientListTable based on the column and order
    this.patientLogReports = this.data.sort((a, b) => {
      if (a[column] < b[column]) return this.sortOrder ? -1 : 1;
      if (a[column] > b[column]) return this.sortOrder ? 1 : -1;
      return 0;
    });
    this.searchForm?.markAsTouched();
    // this.updatePagedData();
  }

  exportList(type) {

    const fromDate = new Date(this.fromDate).toLocaleDateString();
    const toDate = new Date(this.toDate).toLocaleDateString();
    const searchWord = !!this.term ? `Search Word: ${this.term}` : '';
    const regNum = !!this.regNum ? `Reg Num: ${this.regNum}` : '';
    const sourceType = !!this.sourceType ? `Source: ${this.sourceType}` : '';
    const admissionNumber = !!this.admissionNumber ? `Admission Num: ${this.admissionNumber}` : '';
    const action = !!this.action ? `Action: ${this.action}` : '';

    var header = {
      value1: "SNo",
      value2: "Log Date",
      value3: "Patient Detail",
      value4: "Reg Detail",
      value5: "Reference Detail",
      value6: "Source",
      value7: "Action",
      value8: "Notes",
      value9: "User Name"
    }

    var temp = []
    if (!!this.term) {
      temp = this.patientLogReports.filter(list => {
        const values = Object.values(list).toString().toLowerCase();
        return values.includes(this.term.toLowerCase());
      });
    }
    else {
      temp = this.patientLogReports;
    }

    const filterData = [
      "Search Data",
      searchWord,
      `From Date: ${fromDate}`,
      `To Date: ${toDate}`,
      regNum,
      admissionNumber,
      sourceType,
      action
    ].filter(x => x).join(' | ');

    var ExportData = [];
    temp?.forEach((list, index) => {
      ExportData.push({
        value1: index + 1,
        value2: list?.logDate ? this.dateobj.dateUtctoLocal(list?.logDate, 'DD-MM-YYYY h:mm:ss a') : '-',
        value3: list?.patientName + "\n" + (list?.age || 0) + " yrs/" + list?.gender,
        value4: 'Reg No : '+(list?.isunregisterPatientConverted == false ? list?.regNum + ' || Not Yet Registered' : list?.regNum)+(list?.regDate 
          ? ("\nReg Date : " + this.dateobj.dateUtctoLocal(list?.regDate, 'DD-MM-YYYY h:mm:ss a')) 
          : ''),
        value5: list?.sourceType==1 ? '-' : (( ( list?.sourceType==3 || list?.sourceType==4 || list?.sourceType==5 ) ? 'Adm No : ': (list?.sourceType==10)?'Receipt No': (list?.sourceType==12)?'Expense No' : list?.sourceLabel+' No : ') + ((( list?.sourceType==3 || list?.sourceType==4 || list?.sourceType==5 ) ? list?.admissionNumber :  list?.refNo )|| '-')) 
        +(list?.refDate 
          ? ("\n" + list?.sourceLabel + ' Date : ' 
             + this.dateobj.dateUtctoLocal(list?.refDate, 'DD-MM-YYYY h:mm:ss a')) 
          : ''),
        value6: list?.sourceTypeName || '-',
        value7: list?.actionName || '-',
        value8: list?.notes || '-',
        value9: list?.userName || '-'
      });
    });



    var data = [
      { value1: filterData },
      {
        value1: '',
      },
      header,
      ...ExportData,
    ];
    this.filexport.newExcelExport(type, data, header, "Patient Log Management System");
  }



  printEvent() {
    if (this.isClicked) {
      return
    } else {
      this.isClicked = true;
      if (this.count === 0 && !this.printActionInstance?.psDetails) {
        this.printActionInstance?.loadPrinterSettingsAndLogo();
        setTimeout(() => {
          this.printActionInstance?.triggerPrint();
          if (this.printActionInstance?.psDetails != null) {
            this.count = 1;
          }
          this.isClicked = false;
        }, 1500)
      } else {
        this.printActionInstance?.triggerPrint();
        this.isClicked = false;
      }
    }
  }

  loadSourceMaster() {
      this.rolesData.list(`patientUrology/GetNonClinicalSourceMst`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.sourceTypeList = data?.details;
      }, (error) => {
      });
    }
  

}

